import { CardHeading } from "../../../../src/components/article-elements/CardHeading.tsx";
import { MKMRatings } from "../../../../src/data/articles/usmans-deep-dive-on-murders-at-karlov-manor/Ratings.tsx";
import { MonoBlackDeck } from "../../../../src/data/articles/usmans-deep-dive-on-murders-at-karlov-manor/MonoBlackDeck.tsx";
import * as React from 'react';
export default {
  CardHeading,
  MKMRatings,
  MonoBlackDeck,
  React
};